import React, { useState } from 'react';
import {
  Modal,
  Form,
  Row,
  notification,
  Input,
  Col,
  Button,
  Typography,
  Card,
} from 'antd';

import GetLabel from 'DisplayFramework/components/GetLabel';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';

import { AssetAddress, createAssetAddress } from 'services/assets';
import { AimOutlined } from '@ant-design/icons';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import Address from 'components/address/Address';
import SaveButton from 'components/SaveButtonTabsTop';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';
import getEnvValue from 'utils/getEnvValue';

type AddAssetAdressModalProps = {
  visible: boolean;
  onClose: () => void;
  assetid: number;
  refetech: () => void;
  pickPlace: boolean;
  setpickPlace: any;
};
const initialValues = {
  adrenddate: '' as any,
  adrstartdate: '' as any,
  adrstatus: '' as any,
  adrstatusdate: '' as any,
  adrtype: '' as any,
  assetadrid: '' as any,
  assetid: '' as any,
  assetmainadrcity: '' as any,
  assetmainadrcountry: '' as any,
  assetmainadrregion: '' as any,
  assetmainadrstreet1: '' as any,
  assetmainadrstreet2: '' as any,
  assetmainadrzipcode: '' as any,
  assetgpslng: '' as any,
  assetgpslat: '' as any,
};
const AddAssetAdressModal = (props: AddAssetAdressModalProps) => {
  const { visible, onClose, assetid, refetech, pickPlace, setpickPlace } =
    props;

  const [form] = useForm();
  const [closed, setClosed] = useState(false);

  const onfinish = async (values: any) => {
    const assetAddressRequest: AssetAddress = {
      adrenddate: form.getFieldValue('adrenddate'),
      adrstartdate: form.getFieldValue('adrstartdate'),
      adrstatus: form.getFieldValue('adrstatus'),
      adrstatusdate: form.getFieldValue('adrstatusdate'),
      adrtype: form.getFieldValue('adrtype'),
      assetadrid: 0,
      assetid: assetid,
      assetmainadrcity: form.getFieldValue('assetmainadrcity'),
      assetmainadrcountry: form.getFieldValue('assetmainadrcountry'),
      assetmainadrregion: form.getFieldValue('assetmainadrregion'),
      assetmainadrstreet1: form.getFieldValue('assetmainadrstreet1'),
      assetmainadrstreet2: form.getFieldValue('assetmainadrstreet2'),
      assetmainadrzipcode: form.getFieldValue('assetmainadrzipcode'),
      assetgpslng: form.getFieldValue('assetgpslng'),
      assetgpslat: form.getFieldValue('assetgpslat'),
    };
    await createAssetAddress({
      assetid,
      assetAddressRequest,
    })
      .then((res) => {
        if (res.code === '200') {
          notification.success({ message: res.message });
          onClose();
          refetech();
          setClosed(true);
        }
      })
      .catch((res) => {
        notification.error({ message: res.message });
      });
  };

  return (
    (<Modal
      mask={false}
      open={visible && !closed}
      onCancel={onClose}
      style={!getEnvValue('hideMaps') ? { top: 193, position: 'absolute', right: 0 } : {}}
      width={700}
      centered
      title={<GetLabel label="AddAddAddresse" />}
      footer={
        <Row justify="center">
          <Col span={4}>
            <SaveButton onClick={onfinish} comcode="add" />
          </Col>
        </Row>
      }
      destroyOnClose
    >
      <Card>
        <Form
          form={form}
          preserve={false}
          layout="vertical"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
          onFinishFailed={onFinishFailed}
          onFinish={onfinish}
        >
          <Row gutter={8}>
            <Col span={16}>
              <UtinaCard
                comcode="adresse"
                level={5}
                styleCard={{ height: '100%' }}
              >
                <Row>
                  <FormInput col xs={12} name="adrtype">
                    <ParListSelect parcode="ADRTYPE" />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <FormInput col xs={12} name="assetmainadrstreet1">
                    <Input />
                  </FormInput>

                  <FormInput col xs={12} name="assetmainadrstreet2">
                    <Input />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <Address
                    hideRegionGlobal
                    form={form}
                    spanCity={12}
                    spanRegion={12}
                    spanZip={12}
                    spanCountry={12}
                    paysField="assetmainadrcountry"
                    regionField="assetmainadrregion"
                    villeField="assetmainadrcity"
                    codePostalField="assetmainadrzipcode"

                  />
                </Row>
              </UtinaCard>
            </Col>
            <Col span={8}>
              <UtinaCard
                comcode="location"
                level={5}
                styleCard={{ height: '100%' }}
              >
                {' '}
                <Button
                  onClick={() => {
                    setpickPlace(!pickPlace);
                    onClose();
                  }}
                  loading={pickPlace}
                  type="primary"
                  shape="circle"
                  icon={<AimOutlined />}
                  style={{ float: 'left' }}
                />
                <Typography.Paragraph italic>
                  {' '}
                  &nbsp;please click on target button to pick place
                </Typography.Paragraph>
                <Typography.Paragraph italic>
                  {' '}
                  &nbsp;Or fill the fields
                </Typography.Paragraph>
                <FormInput col xs={24} name="assetgpslng">
                  <Input style={{ width: '100%' }} />
                </FormInput>
                <FormInput col xs={24} name="assetgpslat">
                  <Input style={{ width: '100%' }} />
                </FormInput>
              </UtinaCard>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>)
  );
};

export default AddAssetAdressModal;
